import { InteractionOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { DATE_FORMAT_MMDDYYYY_HHMM_A, DateUtils } from "utils/dateutils";

export default function FeatureHistoryItem({ history }: { history: any }) {
  const createdAt = DateUtils.format(
    history.created_at,
    DATE_FORMAT_MMDDYYYY_HHMM_A
  );

  const isEmailHistory = history?.history_source === "EMAIL";

  return (
    <div
      className="leading-relaxed tracking-wide"
      data-testid="feature-history-item"
    >
      <div
        className="flex justify-between"
        data-testid="feature-history-item-header"
      >
        <InteractionOutlined data-testid="feature-history-item-icon" />
        <div
          className="text-xs text-neutral-600"
          data-testid="feature-history-item-date"
        >
          {createdAt}
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: history?.action_description_html }}
        data-testid="feature-history-item-description"
      />
      {isEmailHistory && (
        <Tag
          className="m-0 mt-1 border border-solid border-ciq-gray-300 rounded-md text-ciq-black-a85 !bg-ciq-gray-50 !font-normal"
          data-testid="history-source-email-tag"
        >
          Added via email
        </Tag>
      )}
    </div>
  );
}
